export default {
  bio: "profile",
  update: "profile/update",
  approveNames: "profile/approve-names",
};
